/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';

export interface GetSurveyMarksSubmissionById$Params {
  submissionId: number;
}

export function getSurveyMarksSubmissionById(
  http: HttpClient,
  rootUrl: string,
  params: GetSurveyMarksSubmissionById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getSurveyMarksSubmissionById.PATH,
    'get',
  );
  if (params) {
    rb.path('submissionId', params.submissionId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

getSurveyMarksSubmissionById.PATH =
  '/me/surveyMarks/submissions/{submissionId}';
